<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-19 10:15:25
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-08-03 17:18:14
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\treatment\components\RightContent\RightContent.vue
-->
<template>
  <div class="right-content" v-loading="firstInLoading" element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="content">
      <div class="tabs-item" :class="{'clicked':contentTab==1}" @click="checkItem(1)">
        个人信息
      </div>
      <div class="tabs-item" :class="{'clicked':contentTab==2}" @click="checkItem(2)">入案详情</div>
      <div class="tabs-item" :class="{'clicked':contentTab==4}" @click="checkItem(4)">
        <el-badge :hidden="!patientFilesItemNumber" :value="patientFilesItemNumber" :max="99" class="item">
          对照录入
        </el-badge>
      </div>
      <div class="tabs-item" :class="{'clicked':contentTab==5}" @click="checkItem(5)">
        <el-badge :hidden="!feedbackNumber" :value="feedbackNumber" :max="99" class="item">
          问卷反馈
        </el-badge>

      </div>
      
      <div class="tabs-item" :class="{'clicked':contentTab==10}" @click="checkItem(10)">
        <el-badge :hidden="!evaluationTaskNumber" :value="evaluationTaskNumber" :max="99" class="item">
          运营管理
        </el-badge>
      </div>
      <!-- 客服咨询进入不显示以下tab -->
      <template v-if="routerName!='consultRoom'"> 
        <div class="tabs-item" :class="{'clicked':contentTab==3}" @click="checkItem(3)">逻辑生效</div>
        <div class="tabs-item" :class="{'clicked':contentTab==6}" @click="checkItem(6)">
          <el-badge :hidden="!patientTaskNumber" :value="patientTaskNumber" :max="99" class="item">
            患者任务
          </el-badge> 
        </div>
        <div class="tabs-item" :class="{'clicked':contentTab==7}" @click="checkItem(7)">
          <el-badge :hidden="!caseMgrTaskNumber" :value="caseMgrTaskNumber" :max="99" class="item">
            个案提醒
          </el-badge>
        </div>
        <!-- <div class="tabs-item" :class="{'clicked':contentTab==8}" @click="checkItem(8)">
          患者情况说明
        </div> -->
        <div class="tabs-item" :class="{'clicked':contentTab==9}" @click="checkItem(9)" style="position:relative">
          <!-- <el-badge :hidden="!caseMgrTaskNumber" :value="caseMgrTaskNumber" :max="99" class="item"> -->
            病程记录
          <!-- </el-badge> -->
          <span v-if="patientSymptomData.length > 0" class="red-tag"></span>
        </div>
      </template>
    </div>
    <div class="bottom-content"> 
      <!-- todo:将组件引用至此 使用contentTab区分 -->
      <infoComponent v-if="contentTab==1" :userDetailsData="userDetailsData"
        :userRightDetailsData='userRightDetailsData' :routerName="routerName" @update="checkItem(1)"></infoComponent> 
      <el-scrollbar class="info-box1" v-if="contentTab==2" style="height: 100%;font-size: 12px">
        <!-- todo:将组件引用至此 使用contentTab区分 -->
        <enter-case :enterCaseData="enterCaseData" :routerName="routerName" @update="checkItem(2)"></enter-case>
      </el-scrollbar>
      <!-- <patientRemark v-if="contentTab==8" :patientRemarkData="patientRemarkData" @update="checkItem(8)"></patientRemark> -->
      <crossReference v-if="contentTab == 4" :routerName="routerName" :patientFilesItemV2VO="patientFilesItemV2VO" :patientFilesIteFocusNumber="patientFilesIteFocusNumber"
        :patientFilesItemOtherNumber="patientFilesItemOtherNumber" :schemeNameList="schemeNameList" @getPatientRightData="getPatientRightData"></crossReference>
      <feedBack v-if="contentTab == 5" :routerName="routerName" :feedbackV2VO="feedbackV2VO" :schemeNameList="schemeNameList"
        @getPatientRightData="getPatientRightData"></feedBack>
      <punchAbnormal v-if="contentTab == 6" :patientTaskV2VO="patientTaskV2VO"
        @getPatientRightData="getPatientRightData" :patientId="patientId"></punchAbnormal>
      <task-reminder v-if="contentTab == 7" :caseMgrTaskV2VO="caseMgrTaskV2VO" :logOff="logOff" :schemeNameList="schemeNameList"
        @getPatientRightData="getPatientRightData" :patientId="patientId"></task-reminder>
      <div class="info-box1" v-if="contentTab==3" style="height: 100%;font-size: 12px">
        <el-radio-group v-model="tabPosition" class="top-radio-tab" style="margin-bottom: 28px;">
          <el-radio-button label="first">决策树</el-radio-button>
          <el-radio-button label="second">消息推送计划</el-radio-button>
        </el-radio-group>
        <el-scrollbar v-show="tabPosition == 'first'" class="info-box1" style="height:calc(100% - 128px);font-size: 12px">
          <div>
            <!-- todo:将组件引用至此 使用contentTab区分 -->
            <Collapse v-if="logicData && JSON.stringify(logicData) !== '{}'" :logicList="logicData"></Collapse>
            <span class="no-logic" v-else>暂无逻辑生效</span>
          </div>
        </el-scrollbar>
        <div v-if="tabPosition == 'second'" style="height:calc(100% - 128px)">
          <MsgSendPlan/>
        </div>
      </div>
      <CourseOfDiseaseRecord v-if="contentTab==9"></CourseOfDiseaseRecord>
      <!-- 运营管理 -->
      <OperationManage v-if="contentTab == 10" :routerName="routerName" :evaluationTaskNumber="evaluationTaskNumber"></OperationManage>
    </div>
    <!-- 对照录入弹窗 -->
    <!-- <CrossReferenDialog ref="crossReferenDialog" /> -->
    <!-- 预览问卷弹窗 -->
    <PreviewDialog ref="dialogRef" :paramData="paramData" :imLook="false" :refresh="true" :feedBackItem="feedBackItem">
    </PreviewDialog>
  </div>
</template>

<script>
import local from '@/utils/local.js'
import moment from "moment";
// import CrossReferenDialog from "../../components/CrossReferenceEntry/newindex";

import {
  decisionExecutedRecordList
} from "../../api/crossApi";
import PreviewDialog from "./questionDialog";
import Collapse from "./Collapse.vue"; // 折叠面板
import MsgSendPlan from "./MsgSendPlan.vue"; // 折叠面板
import { getPatientDetailedInformationVO } from "@/views/newPatientmanage/api/index.js";
import { getSchemeNameByPatientId } from "@/views/newPatientmanage/api/treatmentPlan.js";

export default {
  props: {
    rightInfo: Array | Object,
    patientId: {
      type: String
    },
    routerName:{
      type: String,
      default:""
    },
    logOff: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MsgSendPlan,
    // CrossReferenDialog, //对照录入弹窗
    PreviewDialog, //报告处理查看问卷
    Collapse, // 逻辑生效折叠面板
    infoComponent: () => import("./infoComponent.vue"), //信息
    enterCase: () => import("./enterCase.vue"), //入案
    taskReminder: () => import("./taskReminder.vue"), // 任务提醒
    punchAbnormal: () => import("./punchAbnormal.vue"), // 打卡异常
    feedBack: () => import("./feedBack.vue"), // 反馈评估
    crossReference: () => import("./crossReference.vue"),
    patientRemark: () => import("./patientRemark.vue"),
    CourseOfDiseaseRecord: () => import("./CourseOfDiseaseRecord.vue"),
    OperationManage: () => import("./OperationManage.vue")
  },
  data() {
    return {
      tabPosition: 'first',
      contentTab: 1,
      contentTab1: 1,
      // patientId:'',
      activeNameRight: "first",
      activeNameTask: "first",
      confirmStatus: null,
      remark: "",
      feedBackItem: {},
      firstInLoading: false,
      paramData: {}, //预览问卷数据对象
      imgOss: process.env.VUE_APP_OSS_URL, //图片公用拼接地址
      //控制右边根据菜单显示对应html
      contorlRouter: {
        infoRouter: true,
        referenRouter: true,
        feedRouter: true,
        confirRouter: true,
        infoContentShow: true, //入案管理右侧内容
        taskShow: false, //任务管理右侧内容
        punchShow: false //打卡异常右侧内容
      },
      logicData: {}, // 逻辑生效
      //基本信息对象
      informationObj: {},
      //对照录入数组
      referenceArr: [],
      //反馈评估数组
      feedbackArr: [],
      //入案确认申请信息对象
      confirmationObj: {},
      //任务提醒数据数组
      taskRemindArr: [],
      //打卡异常tab标签
      activeName: "first",
      //打卡异常数据数组
      punchErrorArr: [],
      // 历史记录
      historyRecord: [],
      //打卡异常 正常异常筛选
      screen: "",
      pushId: "", //提交确认提交的ID
      itemTypeObj: {}, //对照录入数据
      tableData: [],
      dateMonth: moment().format("yyyy-MM"),
      dateM: Number(moment().format("M")), // 月
      dateY: Number(moment().format("yyyy")), // 年
      logicList: {},
      logicVisible: false,
      editInfo1: false,
      editInfo2: false,
      // 新增
      caseMgrTaskV2VO: {
        keyWord: "",
        wholeCourseId: "",
        page: 0,
        size: 10,
        caseMgrTaskFlag: false, // 未标记任务是否有数据
        finishCaseMgrTaskFlag: false, // 已标记任务是否有数据
        isCaseMgrTaskLoad: false, // 是否点击已加载
        caseMgrTaskVOList: [], // 未标记的任务
        finishCaseMgrTaskVOList: [] // 已标记的任务
      }, // 任务提醒
      patientTaskV2VO: {
        todayPercentage: 0,
        historyPercentage: 0,
        returnVisitTaskStatus: [],
        searchTaskTime: [],
        patientTaskAbnormalVOList: [], // 当日打卡
        patientTaskMonthVOList: [] // 历史记录
      }, // 打卡异常
      feedbackV2VO: {
        keyWord: "",
        wholeCourseId: "",
        page: 0,
        size: 10,
        feedbackFlag: false, // 未标记任务是否有数据
        finishFeedbackFlag: false, // 已标记任务是否有数据
        isfeedbackLoad: false, // 是否点击已加载
        feedbackVOList: [], // 待反馈处理的问卷
        finishFeedbackVOList: [] // 已处理的问卷
      }, // 反馈处理
      patientFilesItemV2VO: {
        keyWord: "",
        wholeCourseId: "",
        page: 0,
        size: 10,
        patientFilesItemFlag: false, // 未标记任务是否有数据
        finishPatientFilesItemFlag: false, // 已标记任务是否有数据
        ispatientFilesItemLoad: false, // 是否点击已加载
        patientFilesItemVOList: [], // 未录入的文件
        finishPatientFilesItemVOList: [] // 已录入的文件
      }, // 对照录入
      schemeNameList: [], // 获取服务名称列表
      userDetailsData: {},
      userRightDetailsData: {},
      enterCaseData: {},
      patientFilesItemNumber: 0,
      feedbackNumber: 0,
      evaluationTaskNumber: 0,
      patientTaskNumber: 0,
      caseMgrTaskNumber: 0,
      patientFilesIteFocusNumber: 0,
      patientFilesItemOtherNumber: 0,
      patientRemarkData: {},
      patientSymptomData: []
    };
  },
  created() { 
    this.getDecisionExecutedList();
  },
  watch: {
    rightInfo(newValue, oldValue) {
      // this.patientId = newValue.patientId
      this.informationObj = {};
      this.referenceArr = [];
      this.feedbackArr = [];
      // this.taskRemindArr = []
      this.confirmationObj = {};
      this.historyRecord = [];
      this.activeName = "first";
      if (newValue.wholeCourseId) {
        this.pushId = newValue.wholeCourseId;
      } else {
        this.pushId = newValue.id;
      }
      this.informationObj = newValue;
      this.referenceArr = newValue.patientFilesItemList;
      this.feedbackArr = newValue.feedbackList;

      this.confirmStatus = newValue.status;

      if (newValue.patientDoctorConfirmVO) {
        this.confirmationObj = newValue.patientDoctorConfirmVO;
      }
      //任务提醒
      if (Array.isArray(newValue) == true) {
        this.taskRemindArr = newValue;
        this.pushId = newValue[0].wholeCourseId;
      }
      //打卡异常
      if (Array.isArray(newValue.rightData)) {
        this.tableData = newValue.rightData;
      }
      this.firstInLoading = false;
      this.getDecisionExecutedList();
    },
    //监听路由控制右侧模块需显示的html
    $route: {
      handler(newRouter) {
        if (newRouter.path == "/case") {
          this.contorlRouter.infoRouter = true;
          this.contorlRouter.referenRouter = true;
          this.contorlRouter.feedRouter = true;
          this.contorlRouter.confirRouter = true;
        } else if (
          newRouter.path == "/case-4" ||
          newRouter.path == "/case-5" ||
          newRouter.path == "/case-2"
        ) {
          this.contorlRouter.infoRouter = true;
          this.contorlRouter.referenRouter = true;
          this.contorlRouter.feedRouter = true;
          this.contorlRouter.confirRouter = false;
        } else if (newRouter.path == "/case-3") {
          this.contorlRouter.infoRouter = false;
          this.contorlRouter.referenRouter = false;
          this.contorlRouter.feedRouter = false;
          this.contorlRouter.confirRouter = false;
          this.contorlRouter.infoContentShow = false;
          this.contorlRouter.taskShow = true;
          this.contorlRouter.punchShow = false;
        } else if (newRouter.path == "/case-6") {
          this.contorlRouter.infoRouter = false;
          this.contorlRouter.referenRouter = false;
          this.contorlRouter.feedRouter = false;
          this.contorlRouter.confirRouter = false;
          this.contorlRouter.infoContentShow = false;
          this.contorlRouter.taskShow = false;
          this.contorlRouter.punchShow = true;
        }
      },
      immediate: true
    },
    patientId(newValue, oldValue) {
      if (newValue) {
        this.resetObjData();
        this.getSchemeNameList(newValue); // 服务名称列表
        // console.log('页面进入执行')
        this.initPatientRightData(newValue, this.contentTab); // 右侧数据接口方法
      }
    },
    '$store.state.patientSubmitSymptom': {
      async handler(newVal,oldVal) {
        // this.getPatientSavePage()  // 病程记录-患者提交症状是否有数据（加红点）
        this.patientSymptomData = this.$store.state.patientSubmitSymptom
      },
      deep: true,
      immediate: true
    },
    "$store.state.serviceItem.value": {
      async handler(newVal, oldVal) {
        if (this.contentTab == 6) {
          this.initPatientRightData(this.patientId, 6); // 右侧数据接口方法
        }
      },
      deep: true
    }
  },
  methods: {
    checkItem(e) { 
      this.contentTab = e;
      let getRightParams = {
        rightType: e,
        keyWord:
          e === 7
            ? this.caseMgrTaskV2VO.keyWord
            : e === 5
            ? this.feedbackV2VO.keyWord
            : e === 4
            ? this.patientFilesItemV2VO.keyWord
            : "",
        rightWholeCourseId:
          e === 7
            ? this.caseMgrTaskV2VO.wholeCourseId
            : e === 5
            ? this.feedbackV2VO.wholeCourseId
            : e === 4
            ? this.patientFilesItemV2VO.wholeCourseId
            : ""
      };
      this.$socket.emit("setRightParams",JSON.stringify(getRightParams),data => {});
      //存参数,便于socket重链后重新发送setRightParams事件
      this.$store.commit("SEARCH_PARAMS", getRightParams);
      this.resetObjData();
      if (e != 9 && e != 10) {
        this.initPatientRightData(this.patientId, e);
      }
    },
    // 重置默认数据
    resetObjData() {
      this.caseMgrTaskV2VO.page = 0;
      this.feedbackV2VO.page = 0;
      this.patientFilesItemV2VO.page = 0;
      this.caseMgrTaskV2VO.isCaseMgrTaskLoad = false;
      this.feedbackV2VO.isfeedbackLoad = false;
      this.patientFilesItemV2VO.ispatientFilesItemLoad = false;
    },
    // 获取逻辑生效列表
    async getDecisionExecutedList() {
      let wholeCourseId =
        this.rightInfo && this.rightInfo.length > 0
          ? this.rightInfo[0].wholeCourseId
          : "";
      let currentWholeCourseId = this.rightInfo.id
        ? this.rightInfo.id
        : wholeCourseId;
      if (!currentWholeCourseId) {
        return;
      }
      let { code, data } = await decisionExecutedRecordList({
        wholeCourseId: currentWholeCourseId,
        activate: true
      });
      if (code === 0) {
        this.$set(this, "logicList", data);
      }
    },
    // 重新调用接口拉取接口列表
    getPatientRightData(type, arrPar) {
      // if (type === 4) {
      //   this.patientFilesItemV2VO = {
      //     ...this.patientFilesItemV2VO,
      //     ispatientFilesItemLoad: true,
      //     page: this.patientFilesItemV2VO.page + 1
      //   }
      // }
      if (arrPar && arrPar.length) {
        this.$set(this, arrPar[0], {
          ...this[arrPar[0]],
          [arrPar[1]]: true,
          page: this[arrPar[0]].page + 1
        });
      }
      let getRightParams = {
        rightType: type,
        keyWord:
          type === 7
            ? this.caseMgrTaskV2VO.keyWord
            : type === 5
            ? this.feedbackV2VO.keyWord
            : type === 4
            ? this.patientFilesItemV2VO.keyWord
            : "",
        rightWholeCourseId:
          type === 7
            ? this.caseMgrTaskV2VO.wholeCourseId
            : type === 5
            ? this.feedbackV2VO.wholeCourseId
            : type === 4
            ? this.patientFilesItemV2VO.wholeCourseId
            : ""
      };
      this.$socket.emit("setRightParams", JSON.stringify(getRightParams), data => {});
       //存参数,便于socket重链后重新发送setRightParams事件
      this.$store.commit("SEARCH_PARAMS", getRightParams);
      this.initPatientRightData(this.patientId, type);
    },
    resetPatientTask() {
      this.patientTaskV2VO.searchTaskTime = []
      this.patientTaskV2VO.returnVisitTaskStatus = []
      this.initPatientRightData(this.patientId, 6);
    },
    // 疗程管理右侧数据接口
    async initPatientRightData(patientId, type) {
      if (type == 9 || type == 10) return
      // debugger mm
      if (!patientId) {
        return;
      }
      let {
        code,
        data: {
          caseMgrTaskV2VO,
          patientTaskV2VO,
          feedbackV2VO,
          patientFilesItemV2VO,
          personalInformationVO,
          patientFilesItemNumber,
          feedbackNumber,
          evaluationTaskNumber,
          patientTaskNumber,
          patientFilesIteFocusNumber,
          patientFilesItemOtherNumber,
          caseMgrTaskNumber,
          patientRemarkVO,
          logicVO,
          wholeCourseMessageVO,
          kinshipName,
          diseaseId,
          diseaseName,
        }
      } = await getPatientDetailedInformationVO({
        patientId,
        type,
        current:
          type === 7
            ? this.caseMgrTaskV2VO.page
            : type === 5
            ? this.feedbackV2VO.page
            : type === 4
            ? this.patientFilesItemV2VO.page
            : 1,
        size:
          type === 7
            ? this.caseMgrTaskV2VO.size
            : type === 5
            ? this.feedbackV2VO.size
            : type === 4
            ? this.patientFilesItemV2VO.size
            : 10,
        keyWord:
          type === 7
            ? this.caseMgrTaskV2VO.keyWord
            : type === 5
            ? this.feedbackV2VO.keyWord
            : type === 4
            ? this.patientFilesItemV2VO.keyWord
            : "",
        wholeCourseId:
          type === 7
            ? this.caseMgrTaskV2VO.wholeCourseId
            : type === 5
            ? this.feedbackV2VO.wholeCourseId
            : type === 4
            ? this.patientFilesItemV2VO.wholeCourseId
            : "",

        returnVisitTaskStatus:
          type === 6
            ? this.patientTaskV2VO.returnVisitTaskStatus
            : [],
        startTime:
          type === 6 && this.patientTaskV2VO.searchTaskTime
            ? this.patientTaskV2VO.searchTaskTime[0]
            : null,
        endTime:
          type === 6 && this.patientTaskV2VO.searchTaskTime
            ? this.patientTaskV2VO.searchTaskTime[1]
            : null,
      });
      if (code === 0) {   
        // console.log(personalInformationVO.patientArchivesLeftVO.id,'personalInformationVO.patientArchivesLeftVO.id')
        if (personalInformationVO) {
          sessionStorage.setItem('archivesId',personalInformationVO.patientArchivesLeftVO.id)
        }
        this.patientFilesItemNumber = patientFilesItemNumber;
        this.feedbackNumber = feedbackNumber;
        this.evaluationTaskNumber = evaluationTaskNumber;
        this.patientFilesIteFocusNumber = patientFilesIteFocusNumber;
        this.patientFilesItemOtherNumber = patientFilesItemOtherNumber;
        this.patientTaskNumber = patientTaskNumber;
        this.caseMgrTaskNumber = caseMgrTaskNumber;
        switch (type) {
          case 7:
            if (
              caseMgrTaskV2VO.caseMgrTaskVOList instanceof Array &&
              caseMgrTaskV2VO.caseMgrTaskVOList.length > 0
            ) {
              this.caseMgrTaskV2VO.caseMgrTaskFlag = true;
            } else {
              this.caseMgrTaskV2VO.caseMgrTaskFlag = false;
            }
            if (caseMgrTaskV2VO.hasNext) {
              this.caseMgrTaskV2VO.finishCaseMgrTaskFlag = true;
            } else {
              this.caseMgrTaskV2VO.finishCaseMgrTaskFlag = false;
            }
            this.caseMgrTaskV2VO.caseMgrTaskVOList =
              caseMgrTaskV2VO.caseMgrTaskVOList;
            this.caseMgrTaskV2VO.finishCaseMgrTaskVOList =
              caseMgrTaskV2VO.finishCaseMgrTaskVOList;
            this.caseMgrTaskV2VO.diseaseId = diseaseId
            this.caseMgrTaskV2VO.diseaseName = diseaseName
            break;
          case 6:
            let patientTaskMonthVOList = patientTaskV2VO.patientTaskMonthVOList.map(
              item => {
                return {
                  ...item,
                  flag: true
                };
              }
            );
            let operationTaskYearMonthVOList = patientTaskV2VO.operationTaskYearMonthVOList.map(
              item => {
                return {
                  ...item,
                  flag: true,
                  operationTaskVOList: item.operationTaskVOList.map(items => {
                    return {
                      ...items,
                      operationTaskVOList: items.operationTaskVOList.map(
                        itemss => {
                          return {
                            ...itemss,
                            visible: false
                          };
                        }
                      )
                    };
                  })
                };
              }
            );
            // this.patientTaskV2VO = patientTaskV2VO;
            this.patientTaskV2VO.historyPercentage = patientTaskV2VO.historyPercentage
            this.patientTaskV2VO.todayPercentage = patientTaskV2VO.todayPercentage
            this.patientTaskV2VO.patientTaskMonthVOList = patientTaskMonthVOList;
            this.patientTaskV2VO.patientTaskAbnormalVOList = patientTaskV2VO.patientTaskAbnormalVOList;
            this.patientTaskV2VO.operationTaskYearMonthVOList = operationTaskYearMonthVOList;
            break;
          case 5:
            // this.feedbackV2VO = feedbackV2VO
            if (
              feedbackV2VO.feedbackVOList instanceof Array &&
              feedbackV2VO.feedbackVOList.length > 0
            ) {
              this.feedbackV2VO.feedbackFlag = true;
            } else {
              this.feedbackV2VO.feedbackFlag = false;
            }
            // total返回的是current+1页的数据条数，total存在则说明需要展示加载按钮否则不需展示加载按钮
            if (feedbackV2VO.hasNext) {
              this.feedbackV2VO.finishFeedbackFlag = true;
            } else {
              this.feedbackV2VO.finishFeedbackFlag = false;
            }
            this.feedbackV2VO.feedbackVOList = feedbackV2VO.feedbackVOList;
            this.feedbackV2VO.finishFeedbackVOList =
              feedbackV2VO.finishFeedbackVOList;
            break;
          case 4:
            // this.patientFilesItemV2VO = patientFilesItemV2VO
            if (patientFilesItemV2VO) {
              if (
                patientFilesItemV2VO.patientFilesItemVOList instanceof Array &&
                patientFilesItemV2VO.patientFilesItemVOList.length > 0
              ) {
                this.patientFilesItemV2VO.patientFilesItemFlag = true;
              } else {
                this.patientFilesItemV2VO.patientFilesItemFlag = false;
              }
              // 判断已录入下一页有没有数据
              if (patientFilesItemV2VO.hasNext) {
                this.patientFilesItemV2VO.finishPatientFilesItemFlag = true;
              } else {
                this.patientFilesItemV2VO.finishPatientFilesItemFlag = false;
              }
              this.patientFilesItemV2VO.patientFilesItemVOList =
                patientFilesItemV2VO.patientFilesItemVOList;
              this.patientFilesItemV2VO.finishPatientFilesItemVOList =
                patientFilesItemV2VO.finishPatientFilesItemVOList;
            }
            break;
          case 1:
            this.userDetailsData = {
              ...personalInformationVO.patientArchivesLeftVO,
              kinshipName
            };
            this.userRightDetailsData = {
              ...personalInformationVO.assistedReproductionVO,
              ...personalInformationVO.patientArchivesRightVO
            }; 
            // console.log('获取患者基本+病例信息',this.userDetailsData.patientName,'患者id',this.userDetailsData.patientId) 
            // 缓存患者档案id，患者id 供患者病例时间历史记录组件处使用
            sessionStorage.setItem("linkArchivesId",  personalInformationVO.patientArchivesLeftVO.id);
            sessionStorage.setItem("linkPatientId",  personalInformationVO.patientArchivesLeftVO.patientId);
            break;
          case 2:
            this.enterCaseData = wholeCourseMessageVO;
            break;
          case 3:
            this.logicData = logicVO.decisionExecutedRecord;
            break;
          case 8:
            this.patientRemarkData = patientRemarkVO;
            break;
        }
      }
    },
    // 获取服务名称列表
    async getSchemeNameList(patientId) {
      let { code, data } = await getSchemeNameByPatientId({ patientId });
      if (code === 0) {
        this.schemeNameList = data.map(item => {
          return {
            ...item,
            name: `${item.name}(${this.filterTypeHandel(item.status)})`
          }
        })
        if (this.schemeNameList && this.schemeNameList.length) {
          this.caseMgrTaskV2VO.wholeCourseId = this.schemeNameList[0].wholeCourseId
          this.patientFilesItemV2VO.wholeCourseId = this.schemeNameList[0].wholeCourseId
        } else {
          this.caseMgrTaskV2VO.wholeCourseId = ''
          this.patientFilesItemV2VO.wholeCourseId = ''
        }
        
      }
    },
    //患者状态
    filterTypeHandel(status) {
      switch (status * 1) {
        case 1:
          return "未申请";
        case 2:
          return "未入案";
        case 3:
          return "评估中";
        case 4:
          return "待医生确认";
        case 5:
          return "进行中";
        // case 6 :
        //     return '医生驳回'
        case 7:
          return "未开始";
        // case 8 :
        //     return '已退款'
        // case 9 :
        //     return '待病人确认'
        // case 10 :
        //     return '病人驳回'
        // case 11 :
        //     return '医生取消'
        case 12:
          return "服务结束";
        default:
          return "未知状态";
      }
    }
  },
  sockets: {
    // 右侧数据
    rightData(data) {
      if (typeof data === "string") {
        data = JSON.parse(data);
      }
      let {
        data: {
          caseMgrTaskV2VO,
          patientTaskV2VO,
          feedbackV2VO,
          patientFilesItemV2VO,
          personalInformationVO,
          patientFilesItemNumber,
          feedbackNumber,
          evaluationTaskNumber,
          patientFilesIteFocusNumber,
          patientFilesItemOtherNumber,
          patientTaskNumber,
          caseMgrTaskNumber,
          patientRemarkVO,
          logicVO,
          wholeCourseMessageVO,
          logOff,
          diseaseId,
          diseaseName,
        }
      } = data.result;
      let type = this.contentTab;
      this.patientFilesItemNumber = patientFilesItemNumber;
      this.feedbackNumber = feedbackNumber;
      this.evaluationTaskNumber = evaluationTaskNumber;
      this.patientFilesIteFocusNumber = patientFilesIteFocusNumber;
      this.patientFilesItemOtherNumber = patientFilesItemOtherNumber;
      this.patientTaskNumber = patientTaskNumber;
      this.caseMgrTaskNumber = caseMgrTaskNumber;
      switch (type) {
        case 7:
          if (
            caseMgrTaskV2VO.caseMgrTaskVOList instanceof Array &&
            caseMgrTaskV2VO.caseMgrTaskVOList.length > 0
          ) {
            this.caseMgrTaskV2VO.caseMgrTaskFlag = true;
          } else {
            this.caseMgrTaskV2VO.caseMgrTaskFlag = false;
          }
          if (caseMgrTaskV2VO.hasNext) {
            this.caseMgrTaskV2VO.finishCaseMgrTaskFlag = true;
          } else {
            this.caseMgrTaskV2VO.finishCaseMgrTaskFlag = false;
          }
          this.caseMgrTaskV2VO.caseMgrTaskVOList =
            caseMgrTaskV2VO.caseMgrTaskVOList;
          this.caseMgrTaskV2VO.finishCaseMgrTaskVOList =
            caseMgrTaskV2VO.finishCaseMgrTaskVOList;
          this.caseMgrTaskV2VO.diseaseId = diseaseId
          this.caseMgrTaskV2VO.diseaseName = diseaseName
          break;
        case 6:
          let patientTaskMonthVOList = patientTaskV2VO.patientTaskMonthVOList.map(
            item => {
              return {
                ...item,
                flag: true
              };
            }
          );
          let operationTaskYearMonthVOList = patientTaskV2VO.operationTaskYearMonthVOList.map(
            item => {
              return {
                ...item,
                flag: true,
                operationTaskVOList: item.operationTaskVOList.map(items => {
                  return {
                    ...items,
                    operationTaskVOList: items.operationTaskVOList.map(
                      itemss => {
                        return {
                          ...itemss,
                          visible: false
                        };
                      }
                    )
                  };
                })
              };
            }
          );
          this.patientTaskV2VO = patientTaskV2VO;
          this.patientTaskV2VO.patientTaskMonthVOList = patientTaskMonthVOList;
          this.patientTaskV2VO.operationTaskYearMonthVOList = operationTaskYearMonthVOList;
          break;
        case 5:
          // this.feedbackV2VO = feedbackV2VO
          if (
            feedbackV2VO.feedbackVOList instanceof Array &&
            feedbackV2VO.feedbackVOList.length > 0
          ) {
            this.feedbackV2VO.feedbackFlag = true;
          } else {
            this.feedbackV2VO.feedbackFlag = false;
          }
          // total返回的是current+1页的数据条数，total存在则说明需要展示加载按钮否则不需展示加载按钮
          if (feedbackV2VO.hasNext) {
            this.feedbackV2VO.finishFeedbackFlag = true;
          } else {
            this.feedbackV2VO.finishFeedbackFlag = false;
          }
          this.feedbackV2VO.feedbackVOList = feedbackV2VO.feedbackVOList;
          this.feedbackV2VO.finishFeedbackVOList =
            feedbackV2VO.finishFeedbackVOList;
          break;
        case 4:
          // this.patientFilesItemV2VO = patientFilesItemV2VO
          if (patientFilesItemV2VO) {
            if (
              patientFilesItemV2VO.patientFilesItemVOList instanceof Array &&
              patientFilesItemV2VO.patientFilesItemVOList.length > 0
            ) {
              this.patientFilesItemV2VO.patientFilesItemFlag = true;
            } else {
              this.patientFilesItemV2VO.patientFilesItemFlag = false;
            }
            // 判断已录入下一页有没有数据
            if (patientFilesItemV2VO.hasNext) {
              this.patientFilesItemV2VO.finishPatientFilesItemFlag = true;
            } else {
              this.patientFilesItemV2VO.finishPatientFilesItemFlag = false;
            }
            this.patientFilesItemV2VO.patientFilesItemVOList =
              patientFilesItemV2VO.patientFilesItemVOList;
            this.patientFilesItemV2VO.finishPatientFilesItemVOList =
              patientFilesItemV2VO.finishPatientFilesItemVOList;
          }
          break;
        case 1:
          // this.userDetailsData = personalInformationVO.patientArchivesLeftVO;
          // this.userRightDetailsData = {
          //   ...personalInformationVO.assistedReproductionVO,
          //   ...personalInformationVO.patientArchivesRightVO
          // };
          break;
        case 2:
          this.enterCaseData = wholeCourseMessageVO;
          break;
        case 3:
          this.logicData = logicVO.decisionExecutedRecord;
          break;
        case 8:
          this.patientRemarkData = patientRemarkVO;
          break;
      }
    }
  }
};
</script>
<style lang="less">
.content-item1,
.content-item2,
.content-item3 {
  .el-tabs {
    height: 100%;
    .el-tabs__header.is-top {
      padding: 0 10px;
      .el-tabs__nav-wrap::after {
        height: 1px !important;
      }
    }
    .el-tabs__content {
      padding: 0 10px;
      height: calc(100% - 56px);
      .el-tab-pane {
        height: 100%;
      }
    }
  }
}

.right-content .month-item3 .el-input__inner {
  border: none !important;
  color: #1a7bfc !important;
}
.right-content .month-item3 .el-input__prefix {
  color: #1a7bfc;
}

.items3-timeline {
  .el-timeline-item__node {
    width: 9px;
    height: 9px;
  }
  .el-timeline-item__tail {
    border-left: 1px solid #e4e7ed;
  }
  .el-timeline-item__node--normal {
    left: 0;
  }
}
</style>
<style scoped lang="less">
@import "./RightContent";
.refeFileName .temporary-tag {
  width: 34px;
  height: 20px;
  background: linear-gradient(180deg, #fd8e8e 0%, #fb5555 100%);
  font-size: 12px;
  font-family: STYuanti-SC-Bold, STYuanti-SC;
  font-weight: bold;
  color: #ffffff;
  line-height: 14px;
  position: absolute;
  top: 0;
  left: 55px;
  display: block;
  text-align: center;
  line-height: 20px;
  z-index: 33;
}
.icon-point {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
.temporary-tag:after {
  content: "";
  width: 0;
  height: 0; 
  border-left: 5px solid #fb5555;
  border-bottom: 5px solid transparent;
  border-top: 5px solid transparent;
  position: absolute;
  top: 15px;
  left: 0;
}
.empty {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.content {
  // overflow-x: auto;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  border-radius: 6px 6px 0px 0px;
  border: 1px solid #d9d9d9;
  // overflow: hidden;
  background: #ffffff;
  .tabs-item {
    flex: 1;
    text-align: center;
    white-space: nowrap;
    cursor: pointer;
    height: 48px;
    line-height: 48px;
    color: rgba(0, 0, 0, 0.65);
    border-right: 1px solid #d9d9d9;
    &.clicked {
      background: #1a7bfc;
      color: #fff;
      border: 0;
    }
  }
}
.bottom-content {
  height: calc(100% - 50px);
  background: #fff;
  .info-box1 {
    position: relative;
    .btn-box {
      margin-top: 16px;
      .btn-item {
        width: 80px;
        display: inline-block;
        vertical-align: top;
        height: 30px;
        background: #ffffff;
        text-align: center;
        border: 1px solid #d9d9d9;
        line-height: 30px;
        color: rgba(0, 0, 0, 0.65);
        &.clicked {
          color: #ffffff;
          background: #1a7bfc;
        }
      }
      .folot {
        float: right;
        margin-right: 26px;
      }
    }
    .no-logic {
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 14px;
      color: #000000;
    }
  }
  ul {
    margin: 25px 24px 40px;
    li {
      margin-bottom: 20px;
      display: flex;
      .leftTitle {
        color: #666;
        font-size: 12px;
        width: 85px;
        margin-right: 15px;
      }
      .text {
        color: #333;
        font-size: 12px;
        flex: 1;
        // font-weight: bold;
      }
    }
  }
}
.red-tag {
  display: block;
  width: 8px;
  height: 8px;
  background: #F14352;
  border-radius: 7px;
  position: absolute;
  top: 10px;
  right: 5px;
}
.top-radio-tab {
  width:100%;
  text-align: center;
  margin-top: 20px;
  /deep/.el-radio-button__inner {
    padding: 0;
    width: 100px;
    height: 34px;
    line-height: 34px;
  }
}
</style>